import ToDoList from './ToDoList';
import todos, { deleteTodo, toggleTodo, saveTodo, domain } from './store';

export default ToDoList;
export { todos, deleteTodo, toggleTodo, saveTodo, domain };



// WEBPACK FOOTER //
// ./src/ToDoList/index.js